/* globals google */
import $ from 'jquery';
require('jquery-colpick');

export const create = ($el) => {
    var $colorInput = $el
        ? $el.find('[data-colorpicker]')
        : $('[data-colorpicker]');

    // ---------------- show color picker
    $colorInput.colpick({
        onSubmit: function(hbs, hex, rgb, el) {
            var $el = $(el),
                $label = $el.closest('.field'),
                $preview = $label.find('.field__color-preview');

            $el.val(hex);
            $preview.css('background-color', '#' + hex);

            $el.colpickHide();
        },
    });
};
export const binds = ($el) => {
    create();
};
